// extracted by mini-css-extract-plugin
export default {"identity-provider-buttons":"_9NSy"};